// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useState } from 'react'
import { func } from 'prop-types'
import InfoGroup from './InfoGroup'
import faqListCoordination from './faqListCoordination'
import faqListProtection from './faqListProtection'

import {
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'

const ModalContent = ({ toggleModal }) => {
  const [activeInfoGroup, setActiveInfoGroup] = useState(null)
  const assignActiveInfoGroup = newInfoGroup => setActiveInfoGroup(currentInfoGroup => (
    currentInfoGroup === newInfoGroup ? null : newInfoGroup
  ))

  return (
    <>
      <ModalHeader toggle={toggleModal}>
        {'COMSEARCH CONNECT FAQs'}
      </ModalHeader>
      <ModalBody>
        <InfoGroup
          {...faqListCoordination}
          activeInfoGroup={activeInfoGroup}
          assignActiveInfoGroup={assignActiveInfoGroup} />
        <InfoGroup
          {...faqListProtection}
          activeInfoGroup={activeInfoGroup}
          assignActiveInfoGroup={assignActiveInfoGroup} />
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={toggleModal}>
          {'Close'}
        </Button>
      </ModalFooter>
    </>
  )
}

ModalContent.propTypes = {
  toggleModal: func.isRequired,
}

export default ModalContent
